import { render } from "./LegoSuccessNotification.vue?vue&type=template&id=8b15b4ac&scoped=true"
import script from "./LegoSuccessNotification.vue?vue&type=script&lang=js"
export * from "./LegoSuccessNotification.vue?vue&type=script&lang=js"

import "./LegoSuccessNotification.vue?vue&type=style&index=0&id=8b15b4ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b15b4ac"

export default script